import type {
  BaseModalContentProps,
  BaseModalFooterProps,
  BaseModalHeaderProps,
  BaseModalProps,
} from '../base-modal'

export const MODAL_SHEET_HEADER_TITLE_ID = 'modal-sheet-header-title'

export type ModalSheetProps = BaseModalProps

export interface ModalSheetHeaderProps extends BaseModalHeaderProps {
  subtitle?: string
  title: string
}

export interface ModalSheetFooterProps extends BaseModalFooterProps {}

export interface ModalSheetContentProps extends BaseModalContentProps {}
